import React from 'react';
import { Modal } from '@vwfs-bronson/bronson-react';

import { useTranslation } from 'react-i18next';
import { WithDefaultCpIntegrationErrors, WithDefaultMarketApiErrors } from '@cp-shared-19/common-utilities';
import { RequestCertificateError } from 'cpes-common';
import { myProfilePagePath } from '../../../navigation/paths';

export type RequestCertificateFormConfirmationModalProps = {
    shown: boolean;
    receivedEmail?: string;
    errorStatus?: WithDefaultMarketApiErrors<WithDefaultCpIntegrationErrors<RequestCertificateError>>;
    /* eslint-disable @typescript-eslint/ban-types */
    closeConfirmationModal: Function;
    /* eslint-enable @typescript-eslint/ban-types */
};

export const RequestCertificateFormConfirmationModal: React.FC<RequestCertificateFormConfirmationModalProps> = ({
    shown,
    receivedEmail,
    errorStatus,
    closeConfirmationModal,
}) => {
    const { t } = useTranslation('request-certificate');
    let title, text, buttonConfirmText: string;

    if (receivedEmail) {
        title = t('confirmation-modal.success.headline');
        text = t('confirmation-modal.success.text', {
            email: receivedEmail,
        });
        buttonConfirmText = t('confirmation-modal.success.confirm');
    } else {
        switch (errorStatus) {
            case 'EMAIL_IS_EMPTY': {
                title = t('confirmation-modal.error.invalid-email.headline');
                text = t('confirmation-modal.error.invalid-email.text', {
                    profilePath: myProfilePagePath(),
                });
                break;
            }
            default: {
                title = t('confirmation-modal.error.unexpected-error.headline');
                text = t('confirmation-modal.error.unexpected-error.text');
                break;
            }
        }
        buttonConfirmText = t('confirmation-modal.error.confirm');
    }

    return (
        <Modal
            shown={shown}
            buttonConfirmText={buttonConfirmText}
            onConfirm={() => closeConfirmationModal()}
            onClose={() => closeConfirmationModal()}
            testId="confirmModal"
            title={title}
        >
            <div dangerouslySetInnerHTML={{ __html: text }} />
        </Modal>
    );
};
